/** 目標/計畫/每期保費暨配置比例/繳別變更 */
import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/C2';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

/** 取得清償自動墊繳保費本息條款說明 */
export function getAgreeTermsC2() {
    return get(`${url}/getAgreeTerms`);
};

/** 清償自動墊繳保費本息條款同意 */
export function postAgreeC2() {
    return post(`${url}/agree`);
};

/** 保戶進入清償自動墊繳保費本息變更前，取得先前清償自動墊繳保費本息記錄 */
export function getInfoC2() {
    return get(`${url}/info`);
};

/** 清償自動墊繳保費本息條款同意 */
export function submitC2(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
